# Ernährung: Futter, Portionen & Fütterungsgewohnheiten

Was Ihr Tier frisst, beeinflusst Energie, Gewicht, Fell und Langzeitgesundheit. Regelmäßige Portionen, hochwertige Zutaten und feste Mahlzeiten machen den größten Unterschied.

<ArticleImage
  src="/images/guide/food-pet-bowl.jpg"
  alt="Futternapf"
  caption="Portionen und Konstanz sind so wichtig wie die Zutaten."
/>

---

<Section emoji="⚖️" title="Portionen & Körperzustand">

<Tip label="Abmessen" text="Portionen abwiegen oder messen, um schleichendes Überfüttern zu vermeiden." />
<Tip label="Körperform" text="Rippen sollten fühlbar, Taille von oben sichtbar sein." />
<Tip label="Leckerlis" text="Unter 10 % der Tageskalorien bleiben." />

</Section>

<ArticleImage
  src="/images/guide/food-rabbit.jpg"
  alt="Ausgewogenes Futter"
  caption="Ein ausgewogener Napf enthält Protein, Ballaststoffe und essenzielle Fette."
/>

<Section emoji="🥩" title="Das passende Futter wählen">

<Tip label="Lebensphase" text="Welpen, Erwachsene und Senioren brauchen unterschiedliche Nährstoffe." />
<Tip label="Gesundheit" text="Niere, Allergien oder Gewicht erfordern oft tierärztliche Diäten." />
<Tip label="Konstanz" text="Marke und Rezeptur möglichst konstant halten." />

<Callout>
Wenn Sie Roh‑ oder Hauskost erwägen, sprechen Sie mit dem Tierarzt über Ausgewogenheit.
</Callout>

</Section>

<ArticleImage
  src="/images/guide/food-pet-water.jpg"
  alt="Wasser"
  caption="Hydration unterstützt Verdauung und Harnwege."
/>

<Section emoji="💧" title="Hydration & smarte Snacks">

<Tip label="Frisches Wasser" text="Wasser täglich wechseln und mehrere Näpfe anbieten." />
<Tip label="Katzen & Wasser" text="Nassfutter oder Trinkbrunnen helfen vielen Katzen." />
<Tip label="Zu vermeiden" text="Schokolade, Trauben/Rosinen, Zwiebeln und Xylit sind tabu." />

</Section>

<Disclaimer title="⚠️ Hinweis">
Dieser Leitfaden ersetzt keine tierärztliche Beratung. Appetitverlust, Erbrechen oder Durchfall immer abklären.
</Disclaimer>
